import Search from 'pages/Search';
import Reports from 'pages/Reports';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';

const PATHS = {
  reports: '/reports',
  search: '/'
};

export const ROUTES = [
  {path: PATHS.search, page: Search, rightsTitle: 'search'},
  {path: PATHS.reports, page: Reports, rightsTitle: 'reports'}
];

export const MENU_TITLES = {
  search: 'Search',
  reports: 'Reports'
};

export const MENU_ITEMS = [
  {icon: ContentPasteSearchIcon, title: MENU_TITLES.search, path: PATHS.search},
  {icon: SummarizeIcon, title: MENU_TITLES.reports, path: PATHS.reports}
];
